import Cookies from 'js-cookie'

const tokenKey = 'user-token'
const openidKey = 'openid'
const shopIdKey = 'shop-id'

export function getToken () {
  return Cookies.get(tokenKey)
}

export function setToken (token) {
  if (token) {
    Cookies.set(tokenKey, token)
  } else {
    Cookies.remove(tokenKey)
  }
}

export function getOpenid () {
  return Cookies.get(openidKey)
}

export function setOpenid (token) {
  return Cookies.set(openidKey, token)
}

export function removeOpenid () {
  return Cookies.remove(openidKey)
}

export function setShopId (shopId) {
  if (shopId) {
    Cookies.set(shopIdKey, shopId)
  } else {
    Cookies.remove(shopIdKey)
  }
}

export function getShopId () {
  const id = Cookies.get(shopIdKey)
  return id ? Number(id) : null
}

export function deCode (str) {
  return decodeURIComponent(atob(str).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  }).join(''))
}
